import React from "react";

const formatTime = (value) => {
    if (!value) { return "—"; }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) { return value; }

    return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
};

const formatDate = (value) => {
    if (!value) { return ""; }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) { return ""; }

    return date.toLocaleDateString([], {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

const ActivityItem = ({ item }) => {
    return (
        <div className="activity-item">
            <div className="activity-time">
                <strong>{formatTime(item.created_at)}</strong>

                <small>
                    {formatDate(item.created_at)}
                </small>
            </div>

            <div className="activity-content">
                <h4>{item.employee}</h4>

                <p>
                    {item.action_label}
                    {" "}
                    <strong>{item.task_title}</strong>
                </p>

                <small>
                    {item.business}
                    {item.department
                        ? ` • ${item.department}`
                        : ""}
                </small>

                {item.remarks && (
                    <div
                        style={{
                            marginTop: "6px",
                            color: "#64748b",
                            fontSize: "13px",
                        }}
                    >
                        {item.remarks}
                    </div>
                )}
            </div>
        </div>
    );
};

const ActivityTimeline = ({ activities = [], loading = false }) => {
    if (loading) {
        return (
            <div
                className="activity-timeline"
                style={{
                    padding: "24px",
                    textAlign: "center",
                }}
            >
                Loading activities...
            </div>
        );
    }

    if (!activities.length) {
        return (
            <div
                className="activity-timeline"
                style={{
                    padding: "32px",
                    textAlign: "center",
                    color: "#64748b",
                }}
            >
                No activities found.
            </div>
        );
    }

    return (
        <div className="activity-timeline">
            {activities.map((activity) => (
                <ActivityItem
                    key={activity.id}
                    item={activity}
                />
            ))}
        </div>
    );
};

export default ActivityTimeline;
